import { createFileRoute } from '@tanstack/react-router';
import z from 'zod';
import { ErrorPage } from './-components/ErrorPage';

export const sapConcurSearchParams = z.object({
  id: z.string().nonempty(),
  requestToken: z.string().nonempty(),
  userId: z.string().nonempty(),
});

export const validateSearch = (search: unknown) => {
  const result = sapConcurSearchParams.safeParse(search);
  if (!result.success) throw result.error;
  return result.data;
};

export const Route = createFileRoute('/integrations/connect/sap-concur/')({
  errorComponent: ({ error }) => <ErrorPage error={error} />,
  validateSearch,
});
